import React, { createContext, useContext, useMemo, useState } from 'react';
import { ProjectWorkspaceModuleKey } from '../types';

interface ProjectWorkspaceContextValue {
  disabledModules: ProjectWorkspaceModuleKey[];
  setDisabledModules: (modules: ProjectWorkspaceModuleKey[]) => void;
}

const ProjectWorkspaceContext = createContext<ProjectWorkspaceContextValue>({
  disabledModules: [],
  setDisabledModules: () => {},
});

export function ProjectWorkspaceProvider({ children }: { children: React.ReactNode }) {
  const [disabledModules, setDisabledModules] = useState<ProjectWorkspaceModuleKey[]>([]);
  const value = useMemo(() => ({ disabledModules, setDisabledModules }), [disabledModules]);

  return (
    <ProjectWorkspaceContext.Provider value={value}>
      {children}
    </ProjectWorkspaceContext.Provider>
  );
}

export function useProjectWorkspaceContext() {
  return useContext(ProjectWorkspaceContext);
}
